import React from 'react'
import { Modal } from 'react-bootstrap'
import { TOKEN_RAIN, TRANSACTION_TYPES, getMarketTokenByLabel } from '../../utils/constants';
import { formatNumbers } from '../../utils/helpers';
import { useSwipeClose } from '../../hooks/useSwipeClose';

const SuccessModalMobile = ({
    show,
    onHide,
    message,
    description,
    isSellTransactionSucceed,
    mblSuccessInfo,
    showShare,
    shareSocialsModal,
}) => {
    const swipeRef = useSwipeClose(show, onHide);
    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                centered
                className="pollmodal sharesocial-modal new-modal-style success-modal-mobile"
                animation={false}
            >
                <Modal.Header ref={swipeRef} onClick={onHide}>
                    <div className="close-div"></div>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent">
                        {mblSuccessInfo?.transactionType !== TRANSACTION_TYPES.CLAIM && mblSuccessInfo?.transactionType !== TRANSACTION_TYPES.ENTER_LIQUIDITY && (
                            <div className="checkmark">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                                    <path d="M7.91699 19.0007L15.8337 26.9173L31.667 11.084" stroke="#212121" strokeWidth="2.53333" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        )}
                        {mblSuccessInfo?.transactionType === TRANSACTION_TYPES.CLAIM && mblSuccessInfo?.winnerOption && (
                            <div
                                className="set-winning-option"
                                style={{
                                    borderColor: mblSuccessInfo.winnerColor,
                                    background: `linear-gradient(180deg, ${mblSuccessInfo.winnerColor}33 0%, ${mblSuccessInfo.winnerColor}0D 100%)`,
                                }}
                            >
                                <div className="inside-box">
                                    <span
                                        className='dot-color'
                                        style={{ backgroundColor: mblSuccessInfo.winnerColor }}
                                    ></span>
                                    <p style={{ color: mblSuccessInfo.winnerColor }}>{mblSuccessInfo.winnerOption}</p>
                                </div>
                            </div>
                        )}
                        <h5 className="trade-text">{message}</h5>
                        {mblSuccessInfo?.transactionType === TRANSACTION_TYPES.ENTER_LIQUIDITY && (
                            <div className="parent-liquidity-wrap">
                                <h4>Liquidity Added</h4>
                                <div className="liquidity-amount">
                                    {mblSuccessInfo.tokenDisplay !== TOKEN_RAIN ? (
                                        <img src={getMarketTokenByLabel(mblSuccessInfo.tokenDisplay)?.icon} alt="token" width="29" height="29" className="img-fluid" />
                                    ) : (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                                            <circle cx="14.498" cy="14.498" r="14.498" fill="#212121" />
                                            <path d="M14.3998 2.89966C14.9759 11.7131 24.8998 10.5678 24.8998 14.4996C24.8998 17.7051 20.1858 19.4231 14.3684 19.4231C8.55093 19.4231 3.83693 17.7051 3.83693 14.4996C3.83344 10.5678 13.7573 11.7131 14.3369 2.89966C7.61511 2.91712 2.1748 8.11998 2.1748 14.5415C2.1748 20.963 7.63257 26.1833 14.3684 26.1833C21.1041 26.1833 26.5619 20.97 26.5619 14.5415C26.5619 8.113 21.1181 2.91712 14.3998 2.89966Z" fill="#E6FF00" />
                                        </svg>
                                    )}
                                    <h2 className="amount-value">{formatNumbers(+mblSuccessInfo.amount)}</h2>
                                    <span className="token-label">{mblSuccessInfo.tokenDisplay}</span>
                                </div>
                            </div>
                        )}
                        {mblSuccessInfo?.optionName && (
                            <p className="para">
                                You placed{' '}
                                <span className="bold-text">{formatNumbers(+mblSuccessInfo.amount)} {mblSuccessInfo.tokenDisplay}</span>
                                {' '}on{' '}
                                <span className="green-text" style={mblSuccessInfo.optionColor ? { color: mblSuccessInfo.optionColor } : {}}>{mblSuccessInfo.optionName}</span>
                            </p>
                        )}
                        {mblSuccessInfo?.transactionType === TRANSACTION_TYPES.CLAIM && (
                            <p className="para">
                                You invested{' '}
                                <span className="bold-text">{mblSuccessInfo.invested}</span>
                                {' '}and made{' '}
                                <span className="bold-text">{mblSuccessInfo.made}</span>
                            </p>
                        )}
                        {description && !mblSuccessInfo?.transactionType && (
                            <p className="para" style={{ maxWidth: '100%' }}>{description}</p>
                        )}
                        {isSellTransactionSucceed && (
                            <p className="para">Check "My Orders" to view details</p>
                        )}
                        {showShare && (
                            <div className="share-text" onClick={() => { onHide(); shareSocialsModal && shareSocialsModal() }} style={{ cursor: 'pointer' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M12 5.33398C13.1046 5.33398 14 4.43855 14 3.33398C14 2.22941 13.1046 1.33398 12 1.33398C10.8954 1.33398 10 2.22941 10 3.33398C10 4.43855 10.8954 5.33398 12 5.33398Z" stroke="#7A7A7A" strokeWidth="1.28571" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4 10C5.10457 10 6 9.10457 6 8C6 6.89543 5.10457 6 4 6C2.89543 6 2 6.89543 2 8C2 9.10457 2.89543 10 4 10Z" stroke="#7A7A7A" strokeWidth="1.28571" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M12 14.6665C13.1046 14.6665 14 13.7711 14 12.6665C14 11.5619 13.1046 10.6665 12 10.6665C10.8954 10.6665 10 11.5619 10 12.6665C10 13.7711 10.8954 14.6665 12 14.6665Z" stroke="#7A7A7A" strokeWidth="1.28571" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M5.72656 9.00635L10.2799 11.6597" stroke="#7A7A7A" strokeWidth="1.28571" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.2732 4.33984L5.72656 6.99318" stroke="#7A7A7A" strokeWidth="1.28571" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <p>Share</p>
                            </div>
                        )}
                        <div className="btn-buy">
                            <button onClick={onHide}>Done</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SuccessModalMobile
